import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

interface CentroCustoItem {
  id: number;
  nome: string;
  descricao: string;
  ativo: boolean;
  dataCriacao?: string;
}

@Component({
  selector: 'app-centro-custos',
  templateUrl: './centro-custos.component.html',
  styleUrls: ['./centro-custos.component.scss']
})
export class CentroCustosComponent implements OnInit {
  itens: CentroCustoItem[] = [];

  modalRef: NgbModalRef | null = null;
  editandoId = 0;
  nome = '';
  descricao = '';
  ativo = true;

  constructor(
    private ajaxService: AjaxService,
    private util: UtilService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.carregar();
  }

  carregar(): void {
    this.util.showLoading();
    this.ajaxService.get(`${API}financeiro/centrocustos`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        const data = this.extrairLista(response);
        this.itens = data.map((x: any) => {
          const item = this.util.converterParaLowercase(x || {});
          return {
            id: Number(item.id || 0),
            nome: String(item.nome || ''),
            descricao: String(item.descricao || ''),
            ativo: Boolean(item.ativo),
            dataCriacao: String(item.datacriacao || '')
          };
        })
        .filter((x: CentroCustoItem) => x.id > 0)
        .sort((a: CentroCustoItem, b: CentroCustoItem) => a.id - b.id);
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Não foi possível carregar os centros de custos.');
      }
    });
  }

  novo(modal: TemplateRef<any>): void {
    this.editandoId = 0;
    this.nome = '';
    this.descricao = '';
    this.ativo = true;
    this.modalRef = this.modalService.open(modal, { backdrop: 'static' });
  }

  editar(item: CentroCustoItem, modal: TemplateRef<any>): void {
    this.editandoId = item.id;
    this.nome = item.nome;
    this.descricao = item.descricao;
    this.ativo = item.ativo;
    this.modalRef = this.modalService.open(modal, { backdrop: 'static' });
  }

  salvar(): void {
    if (!this.nome.trim()) {
      this.util.toasterShowError('Atenção', 'Nome é obrigatório.');
      return;
    }

    const payload = {
      nome: this.nome.trim(),
      descricao: this.descricao,
      ativo: this.ativo
    };

    this.util.showLoading();
    const request = this.editandoId > 0
      ? this.ajaxService.put(`${API}financeiro/centrocustos/${this.editandoId}`, payload)
      : this.ajaxService.post(`${API}financeiro/centrocustos`, payload);

    request.subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response.message || 'Não foi possível salvar.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', this.editandoId > 0 ? 'Centro de custo atualizado com sucesso!' : 'Centro de custo cadastrado com sucesso!');
        this.modalRef?.close();
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar centro de custo.');
      }
    });
  }

  excluir(item: CentroCustoItem): void {
    this.util.showLoading();
    this.ajaxService.delete(`${API}financeiro/centrocustos/${item.id}`).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response.message || 'Não foi possível excluir.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Centro de custo excluído com sucesso!');
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao excluir centro de custo.');
      }
    });
  }

  private extrairLista(response: any): any[] {
    let atual = response;
    for (let i = 0; i < 3; i++) {
      if (Array.isArray(atual)) break;
      if (atual && typeof atual === 'object' && Object.prototype.hasOwnProperty.call(atual, 'data') && atual.data != null) {
        atual = atual.data;
      } else {
        break;
      }
    }
    if (Array.isArray(atual)) return atual;
    if (atual && typeof atual === 'object') return Object.values(atual).filter((x: any) => x && typeof x === 'object');
    return [];
  }
}
